import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M15.371 10.715l2.85-2.857m0 0L15.37 5m2.85 2.858l-7.29.001c-2.862 0-5.181 2.326-5.181 5.196 0 2.869 2.32 5.195 5.18 5.195h6.907"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M16.287 10.46L20 6.748m0 0l-3.713-3.713M20 6.748l-9.5.002a6.75 6.75 0 000 13.5h9"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M32.467 21.022l7.366-7.385m0 0L32.467 6.25m7.366 7.387l-18.845.004c-7.395 0-13.39 6.013-13.39 13.43 0 7.416 5.995 13.429 13.39 13.429H38.84"
  }))
};
export var Redo = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});